// checks for the following: null, undefined, "null" and string.empty ('')
export default (toCheck:any) => toCheck === null || toCheck === undefined || toCheck === "null" || toCheck === "";